import React, { useEffect, useState } from 'react';
import { VersionCardProps } from '@/components/cards/VersionCard';
import { CompactDropdownOptionProps } from '@/components/compactDropdown/CompactDropdown';
import ListingHeader from '@/components/listingHeader/ListingHeader';
import VersionListing from '@/components/versionsListing/VersionsListing';
import VersionsPanelStyled from './VersionsPanel.styled';
import { useActiveBlockVersionFromCookie } from '@/hooks/useActiveBlockVersionFromCookie';
import PanelWrapper from '@/components/panelWrapper/PanelWrapper';

interface VersionsPanelProps {
  title?: string;
  id?: string;
  branches?: CompactDropdownOptionProps[];
  versions?: VersionCardProps[];
  onClose?: () => void;
  onBack?: () => void;
}

const VersionsPanel = ({
  title,
  id = '',
  branches,
  versions = [],
  onClose,
  onBack,
}: VersionsPanelProps) => {
  const [branch, setBranch] = useState<string>('');
  const [_branches, setBranches] = useState<any>();

  useEffect(() => {
    if (branch) {
      const filtered = versions?.filter(
        (ver: VersionCardProps) => ver.id === branch
      );
      setBranches(filtered);
    } else setBranches(versions);
  }, [branch]);

  const { branch: branchFromCookie, version: versionFromCookie } =
    useActiveBlockVersionFromCookie(id);

  const overriddenVersion = versions?.filter(
    (v: any) =>
      (v.versionNo === parseInt(versionFromCookie) || !versionFromCookie) &&
      branchFromCookie === v.id
  )?.[0];

  const [selectedVersion, setSelectedVersion] = useState<any>();

  const getSelectedVersion = (version: any) => {
    if (
      (overriddenVersion?.guid === version?.guid && !selectedVersion) ||
      (version?.defaultSelected && !overriddenVersion && !selectedVersion)
    )
      return true;
    return selectedVersion?.guid === version?.guid;
  };

  return (
    <PanelWrapper>
      <VersionsPanelStyled>
        <PanelWrapper.Header title={title} onBack={onBack} onClose={onClose} />
        <ListingHeader
          title={versions?.length > 1 ? 'Block versions' : 'Block version'}
          branches={branches}
          branch={branch}
          setBranch={(e: any) => setBranch(e.target.value)}
        />
        <VersionListing
          branches={_branches}
          getSelectedVersion={getSelectedVersion}
          setSelectedVersion={setSelectedVersion}
        />
        <PanelWrapper.Footer selected={selectedVersion} />
      </VersionsPanelStyled>
    </PanelWrapper>
  );
};

export default VersionsPanel;
